import { ExternalOperationType } from "amnPos/shiftsAndExternals/externalOperations/ExternalOperationData";
import {
  ApprovalSource,
  ApprovalSourceType,
  ApprovalType,
  IItemApproval,
  TicketItem,
} from "amnPos/ticket/Ticket";
import { PermissionErrorType } from "amnShared/Permissions/IPermissions";
import { StatusBadgeStyle } from "components/interfaces/IStatusBadge";
import { OrderType } from "models/common-props/TransactionTypes";

export function GetApprovalBadgeStyle(
  approvalType: ApprovalType,
): StatusBadgeStyle {
  let style = StatusBadgeStyle.Grey;
  switch (approvalType) {
    case ApprovalType.SupervisorAddPickUpOrder:
    case ApprovalType.SupervisorAddDeliveryOrder:
    case ApprovalType.SupervisorHandleTableOrder:
    case ApprovalType.SupervisorAddNewClient:
    case ApprovalType.SupervisorAddNewAddress:
      style = StatusBadgeStyle.Green;
      break;
    case ApprovalType.SupervisorDeleteExternalTransaction:
    case ApprovalType.SupervisorRemoveItem:
    case ApprovalType.SupervisorCancelOrder:
    case ApprovalType.SupervisorCancelOrderAfterPreparationStarts:
    case ApprovalType.SupervisorCancelOrderAfterServed:
    case ApprovalType.SupervisorCancelItemAfterPreparationStarts:
    case ApprovalType.SupervisorCancelItemAfterServed:
      style = StatusBadgeStyle.Red;
      break;
    case ApprovalType.SupervisorPayToClient:
    case ApprovalType.SupervisorReciveFromClient:
    case ApprovalType.SupervisorPayToCenteralBox:
    case ApprovalType.SupervisorReciveFromCenteralBox:
    case ApprovalType.SupervisorReceivePrepayment:
    case ApprovalType.SupervisorSettlePickupOrder:
    case ApprovalType.SupervisorSettleDeliveryTrip:
    case ApprovalType.SupervisorSettleTableOrder:
      style = StatusBadgeStyle.Purple;
      break;
    case ApprovalType.SupervisorItemDiscount:
    case ApprovalType.SupervisorAllItemDiscount:
    case ApprovalType.SupervisorChangeItemPrice:
    case ApprovalType.SupervisorDecreaseItemQuantity:
    case ApprovalType.SupervisorChangeExchgangeRate:
    case ApprovalType.SupervisorEditDeliveryFees:
    case ApprovalType.SupervisorEditSavedOrder:
    case ApprovalType.SupervisorModifyExistingClient:
    case ApprovalType.SupervisorChangeDefaultCountryAndProvince:
    case ApprovalType.SupervisorModifyAddress:
    case ApprovalType.SupervisorChangeMenu:
    case ApprovalType.SupervisorChangeMenuWhenOpenOrder:
    case ApprovalType.SupervisorChangeItemQuantityAfterPreparationStarts:
    case ApprovalType.SupervisorChangeItemQuantityAfterServed:
    case ApprovalType.SupervisorReturnOrderFromInPreparation:
    case ApprovalType.SupervisorEndPreparationInKitchenWindow:
    case ApprovalType.SupervisorMoveOrder:
    case ApprovalType.SupervisorMoveOrderItems:
    case ApprovalType.SupervisorPrintCustomizationBeforeCollect:
      style = StatusBadgeStyle.Orange;
      break;
    case ApprovalType.SupervisorShowSettledTransaction:
    case ApprovalType.SupervisorViewCalculatedCash:
    case ApprovalType.SupervisorViewCustomerBalanceStatement:
    case ApprovalType.SupervisorShowCustomerBalance:
    case ApprovalType.SupervisorViewCalculatedCashDetails:
    case ApprovalType.SupervisorViewCalculatedNonCashDetails:
    case ApprovalType.SupervisorViewShiftDigest:
    case ApprovalType.SupervisorViewMaterialsAndServicesTransactionsDetail:
    case ApprovalType.SupervisorViewExternalTransactionsDetails:
    case ApprovalType.SupervisorViewClosingDetails:
      style = StatusBadgeStyle.OutlinedBlue;
      break;
    default:
      style = StatusBadgeStyle.Grey;
      break;
  }
  return style;
}

export function GetNeededApproval(
  permissionLack: PermissionErrorType,
): ApprovalType {
  switch (permissionLack) {
    case PermissionErrorType.CantPayToClient:
      return ApprovalType.SupervisorPayToClient;
    case PermissionErrorType.CantReceiveFromClient:
      return ApprovalType.SupervisorReciveFromClient;
    case PermissionErrorType.CantPayToCentralBox:
      return ApprovalType.SupervisorPayToCenteralBox;
    case PermissionErrorType.CantReceiveFromCentralBox:
      return ApprovalType.SupervisorReciveFromCenteralBox;
    case PermissionErrorType.ExceededAllowedMaxTransactionValue:
      return ApprovalType.SupervisorMaxAllowedTransaction;
    case PermissionErrorType.CantDeleteExternalTransaction:
      return ApprovalType.SupervisorDeleteExternalTransaction;
    case PermissionErrorType.CantChangePrice:
      return ApprovalType.SupervisorChangeItemPrice;
    case PermissionErrorType.CantSellInDebt:
      return ApprovalType.SupervisorSellWithDept;
    case PermissionErrorType.CantDeleteAnItem:
      return ApprovalType.SupervisorRemoveItem;
    case PermissionErrorType.CantReduceQuantity:
      return ApprovalType.SupervisorDecreaseItemQuantity;
    case PermissionErrorType.CantViewSettledTransactions:
      return ApprovalType.SupervisorShowSettledTransaction;
    case PermissionErrorType.CantReprintSettledTransaction:
      return ApprovalType.SupervisorRepeatPrintingSettledTransaction;
    case PermissionErrorType.CantOpenDrawerManually:
      return ApprovalType.SupervisorManuallyOpenDrawer;
    case PermissionErrorType.CantMakeDiscountOnItem:
      return ApprovalType.SupervisorItemDiscount;
    case PermissionErrorType.CantMakeDiscountOnTransaction:
      return ApprovalType.SupervisorAllItemDiscount;
    case PermissionErrorType.CantUseFc:
      return ApprovalType.SupervisorUseForignCurrencies;
    case PermissionErrorType.CantPayForReturnsInFc:
      return ApprovalType.SupervisorUseForignCurrencies;
    case PermissionErrorType.CantModifyExchangeRates:
      return ApprovalType.SupervisorChangeExchgangeRate;
    case PermissionErrorType.CantCloseShift:
      return ApprovalType.SupervisorCloseShift;
    case PermissionErrorType.CantViewCalculatedCash:
      return ApprovalType.SupervisorViewCalculatedCash;
    case PermissionErrorType.CantPostCashToNextShift:
      return ApprovalType.SupervisorPostCashToNextShift;
    case PermissionErrorType.CantUnCloseShift:
      return ApprovalType.SupervisorUnCloseShift;
    case PermissionErrorType.CantPrintShiftSummary:
      return ApprovalType.SupervisorPrintShiftSummary;
    case PermissionErrorType.CantPrintCustomizationBeforeCollect:
      return ApprovalType.SupervisorPrintCustomizationBeforeCollect;
    case PermissionErrorType.CantViewCustomerBalanceStatement:
      return ApprovalType.SupervisorViewCustomerBalanceStatement;
    case PermissionErrorType.CantShowCustomerBalance:
      return ApprovalType.SupervisorShowCustomerBalance;
    case PermissionErrorType.CantViewCalculatedCashDetails:
      return ApprovalType.SupervisorViewCalculatedCashDetails;
    case PermissionErrorType.CantViewCalculatedNonCashDetails:
      return ApprovalType.SupervisorViewCalculatedNonCashDetails;
    case PermissionErrorType.CantViewShiftDigest:
      return ApprovalType.SupervisorViewShiftDigest;
    case PermissionErrorType.CantViewMaterialsAndServicesTransactionsDetail:
      return ApprovalType.SupervisorViewMaterialsAndServicesTransactionsDetail;
    case PermissionErrorType.CantViewExternalTransactionsDetails:
      return ApprovalType.SupervisorViewExternalTransactionsDetails;
    case PermissionErrorType.CantViewClosingDetails:
      return ApprovalType.SupervisorViewClosingDetails;
    case PermissionErrorType.CantChangeCentralBoxReceiptNumberMandatory:
      return ApprovalType.SupervisorChangeCentralBoxReceiptNumberMandatory;
    // Order
    case PermissionErrorType.CantAddPickUpOrder:
      return ApprovalType.SupervisorAddPickUpOrder;
    case PermissionErrorType.CantAddDeliveryOrder:
      return ApprovalType.SupervisorAddDeliveryOrder;
    case PermissionErrorType.CantHandleTableOrder:
      return ApprovalType.SupervisorHandleTableOrder;
    case PermissionErrorType.CantEditDeliveryFees:
      return ApprovalType.SupervisorEditDeliveryFees;
    case PermissionErrorType.CantDeleteExternalTransaction:
      return ApprovalType.SupervisorDeleteExternalTransaction;
    case PermissionErrorType.CantReceivePrepayment:
      return ApprovalType.SupervisorReceivePrepayment;
    case PermissionErrorType.CantCancelOrder:
      return ApprovalType.SupervisorCancelOrder;
    case PermissionErrorType.CantEditSavedOrder:
      return ApprovalType.SupervisorEditSavedOrder;
    case PermissionErrorType.CantUseOrderManagementTab:
      return ApprovalType.SupervisorUseOrderManagementTab;
    case PermissionErrorType.CantUseDeliveryOrdersManagement:
      return ApprovalType.SupervisorUseDeliveryOrdersManagement;
    case PermissionErrorType.CantSettlePickupOrder:
      return ApprovalType.SupervisorSettlePickupOrder;
    case PermissionErrorType.CantSettleDeliveryTrip:
      return ApprovalType.SupervisorSettleDeliveryTrip;
    case PermissionErrorType.CantSettleTableOrder:
      return ApprovalType.SupervisorSettleTableOrder;
    case PermissionErrorType.CantMoveOrder:
      return ApprovalType.SupervisorMoveOrder;
    case PermissionErrorType.CantMoveOrderItems:
      return ApprovalType.SupervisorMoveOrderItems;
    // Client
    case PermissionErrorType.CantAddNewClient:
      return ApprovalType.SupervisorAddNewClient;
    case PermissionErrorType.CantModifyExistingClient:
      return ApprovalType.SupervisorModifyExistingClient;
    case PermissionErrorType.CantChangeDefaultCountryAndProvince:
      return ApprovalType.SupervisorChangeDefaultCountryAndProvince;
    case PermissionErrorType.CantAddNewAddress:
      return ApprovalType.SupervisorAddNewAddress;
    case PermissionErrorType.CantModifyAddress:
      return ApprovalType.SupervisorModifyAddress;
    // Menus
    case PermissionErrorType.CantChangeMenu:
      return ApprovalType.SupervisorChangeMenu;
    case PermissionErrorType.CantUseMenuOutsideOperatingHours:
      return ApprovalType.SupervisorUseMenuOutsideOperatingHours;
    case PermissionErrorType.CantChangeMenuWhenOpenOrder:
      return ApprovalType.SupervisorChangeMenuWhenOpenOrder;
    // PreparingAndServing
    case PermissionErrorType.CantCancelOrderAfterPreparationStarts:
      return ApprovalType.SupervisorCancelOrderAfterPreparationStarts;
    case PermissionErrorType.CantCancelOrderAfterServed:
      return ApprovalType.SupervisorCancelOrderAfterServed;
    case PermissionErrorType.CantCancelItemAfterPreparationStarts:
      return ApprovalType.SupervisorCancelItemAfterPreparationStarts;
    case PermissionErrorType.CantCancelItemAfterServed:
      return ApprovalType.SupervisorCancelItemAfterServed;
    case PermissionErrorType.CantChangeItemQuantityAfterPreparationStarts:
      return ApprovalType.SupervisorChangeItemQuantityAfterPreparationStarts;
    case PermissionErrorType.CantChangeItemQuantityAfterServed:
      return ApprovalType.SupervisorChangeItemQuantityAfterServed;
    case PermissionErrorType.CantReturnOrderFromInPreparation:
      return ApprovalType.SupervisorReturnOrderFromInPreparation;
    case PermissionErrorType.CantEndPreparationInKitchenWindow:
      return ApprovalType.SupervisorEndPreparationInKitchenWindow;
    case PermissionErrorType.CantSendEReceipt:
      return ApprovalType.SupervisorSendEReceipt;

    default:
      return ApprovalType.NONE;
  }
}
export function MappTicketTypeToApprovalSourceType(
  ticketType: OrderType,
): ApprovalSourceType {
  switch (ticketType) {
    case OrderType.none:
      return ApprovalSourceType.Sales;
    case OrderType.delivery:
      return ApprovalSourceType.DeliveryOrder;
    case OrderType.pickup:
      return ApprovalSourceType.PickupOrder;
    case OrderType.fastService:
      return ApprovalSourceType.FastService;
    case OrderType.fullService:
      return ApprovalSourceType.FullService;
  }
}

export function MapExternalOperationTypeToApprovalSourceType(
  extOpType: ExternalOperationType,
) {
  switch (extOpType) {
    case ExternalOperationType.Debit:
      return ApprovalSourceType.ReceiveFromClient;
    case ExternalOperationType.Credit:
      return ApprovalSourceType.PayToClient;
    case ExternalOperationType.PayToCentralCash:
      return ApprovalSourceType.PayToCenteralCash;
    case ExternalOperationType.ReceiveFromCentralCash:
      return ApprovalSourceType.ReceiveFromCenteralCash;
  }
}

export function MappClientCommandToApprovalSourceType(
  approvalType: ApprovalType,
): ApprovalSourceType {
  switch (approvalType) {
    case ApprovalType.SupervisorSettlePickupOrder:
      return ApprovalSourceType.SettlePickupOrder;
    case ApprovalType.SupervisorMoveOrder:
      return ApprovalSourceType.MoveOrder;
    case ApprovalType.SupervisorMoveOrderItems:
      return ApprovalSourceType.MoveOrderItems;
    case ApprovalType.SupervisorEditSavedOrder:
      return ApprovalSourceType.EditSavedOrder;
    case ApprovalType.SupervisorCancelOrder:
      return ApprovalSourceType.CancelOrder;
    case ApprovalType.SupervisorSettleTableOrder:
      return ApprovalSourceType.SettleTableOrder;
    case ApprovalType.SupervisorShowSettledTransaction:
      return ApprovalSourceType.ShowSettledTransaction;
    case ApprovalType.SupervisorManuallyOpenDrawer:
      return ApprovalSourceType.ManuallyOpenDrawer;
    case ApprovalType.SupervisorRepeatPrintingSettledTransaction:
      return ApprovalSourceType.RepeatPrintingSettledTransaction;
    case ApprovalType.SupervisorPayToClient:
      return ApprovalSourceType.PayToClient;
    case ApprovalType.SupervisorReciveFromClient:
      return ApprovalSourceType.ReceiveFromClient;
    case ApprovalType.SupervisorPayToCenteralBox:
      return ApprovalSourceType.PayToCenteralCash;
    case ApprovalType.SupervisorReciveFromCenteralBox:
      return ApprovalSourceType.ReceiveFromCenteralCash;
    case ApprovalType.SupervisorDeleteExternalTransaction:
      return ApprovalSourceType.DeleteExternalTransaction;
    case ApprovalType.SupervisorMaxAllowedTransaction:
      return ApprovalSourceType.MaxAllowedTransaction;
    case ApprovalType.SupervisorCloseShift:
      return ApprovalSourceType.CloseShift;
    case ApprovalType.SupervisorUnCloseShift:
      return ApprovalSourceType.UnCloseShift;
    case ApprovalType.SupervisorPostCashToNextShift:
      return ApprovalSourceType.PostCashToNextShift;
    case ApprovalType.SupervisorViewCalculatedCash:
      return ApprovalSourceType.ViewCalculatedCash;
    case ApprovalType.SupervisorPrintShiftSummary:
      return ApprovalSourceType.PrintShiftSummary;
    case ApprovalType.SupervisorChangeCentralBoxReceiptNumberMandatory:
      return ApprovalSourceType.ChangeCentralBoxReceiptNumberMandatory;
    case ApprovalType.SupervisorViewCustomerBalanceStatement:
      return ApprovalSourceType.ViewCustomerBalanceStatement;
    case ApprovalType.SupervisorViewShiftDigest:
      return ApprovalSourceType.ViewShiftDigest;
    case ApprovalType.SupervisorViewCalculatedCashDetails:
      return ApprovalSourceType.ViewCalculatedCashDetails;
    case ApprovalType.SupervisorViewCalculatedNonCashDetails:
      return ApprovalSourceType.ViewCalculatedNonCashDetails;
    case ApprovalType.SupervisorViewMaterialsAndServicesTransactionsDetail:
      return ApprovalSourceType.ViewMaterialsAndServicesTransactionsDetail;
    case ApprovalType.SupervisorViewExternalTransactionsDetails:
      return ApprovalSourceType.ViewExternalTransactionsDetails;
    case ApprovalType.SupervisorViewClosingDetails:
      return ApprovalSourceType.ViewClosingDetails;
    case ApprovalType.SupervisorShowCustomerBalance:
      return ApprovalSourceType.ShowCustomerBalance;

    case ApprovalType.SupervisorEditDeliveryFees:
      return ApprovalSourceType.EditDeliveryFees;
    case ApprovalType.SupervisorReceivePrepayment:
      return ApprovalSourceType.ReceivePrepayment;

    case ApprovalType.SupervisorUseOrderManagementTab:
      return ApprovalSourceType.UseOrderManagementTab;
    case ApprovalType.SupervisorUseDeliveryOrdersManagement:
      return ApprovalSourceType.UseDeliveryOrdersManagement;
    case ApprovalType.SupervisorMoveOrder:
      return ApprovalSourceType.FullService;
    case ApprovalType.SupervisorMoveOrderItems:
      return ApprovalSourceType.FullService;

    case ApprovalType.SupervisorSettleDeliveryTrip:
      return ApprovalSourceType.SettleDeliveryTrip;
    case ApprovalType.SupervisorAddNewClient:
      return ApprovalSourceType.AddNewClient;
    case ApprovalType.SupervisorModifyExistingClient:
      return ApprovalSourceType.ModifyExistingClient;
    case ApprovalType.SupervisorChangeDefaultCountryAndProvince:
      return ApprovalSourceType.ChangeDefaultCountryAndProvince;
    case ApprovalType.SupervisorAddNewAddress:
      return ApprovalSourceType.AddNewAddress;
    case ApprovalType.SupervisorModifyAddress:
      return ApprovalSourceType.ModifyAddress;
    case ApprovalType.SupervisorChangeMenu:
      return ApprovalSourceType.ChangeMenu;
    case ApprovalType.SupervisorUseMenuOutsideOperatingHours:
      return ApprovalSourceType.UseMenuOutsideOperatingHours;
    case ApprovalType.SupervisorChangeMenuWhenOpenOrder:
      return ApprovalSourceType.ChangeMenuWhenOpenOrder;
    case ApprovalType.SupervisorCancelOrderAfterPreparationStarts:
      return ApprovalSourceType.CancelOrderAfterPreparationStarts;
    case ApprovalType.SupervisorCancelOrderAfterServed:
      return ApprovalSourceType.CancelOrderAfterServed;
    case ApprovalType.SupervisorCancelItemAfterPreparationStarts:
      return ApprovalSourceType.CancelItemAfterPreparationStarts;
    case ApprovalType.SupervisorCancelItemAfterServed:
      return ApprovalSourceType.CancelItemAfterServed;
    case ApprovalType.SupervisorChangeItemQuantityAfterPreparationStarts:
      return ApprovalSourceType.ChangeItemQuantityAfterPreparationStarts;
    case ApprovalType.SupervisorChangeItemQuantityAfterServed:
      return ApprovalSourceType.ChangeItemQuantityAfterServed;
    case ApprovalType.SupervisorReturnOrderFromInPreparation:
      return ApprovalSourceType.ReturnOrderFromInPreparation;
    case ApprovalType.SupervisorEndPreparationInKitchenWindow:
      return ApprovalSourceType.EndPreparationInKitchenWindow;
    case ApprovalType.SupervisorPrintCustomizationBeforeCollect:
      return ApprovalSourceType.PrintCustomizationBeforeCollect;
    case ApprovalType.SupervisorSendEReceipt:
      return ApprovalSourceType.SendEReceipt;
    default:
      return ApprovalSourceType.None;
  }
}

export function GetItemsApprovals(
  items: TicketItem[],
  discount: number,
): IItemApproval[] {
  return items.map((item) => {
    return {
      id: item.itemId,
      discountPercentageAllowed: discount,
      valueAllowed: (item.total * discount) / 100,
    } as IItemApproval;
  });
}
